var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavingHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waving-hand-skin-2-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7138 13.0628C16.0063 13.385 16.2676 13.8068 16.1563 13.9182C16.0449 14.0296 15.7034 13.8276 15.4421 13.5662C15.1807 13.3049 14.5571 16.0819 14.4962 16.2229C14.4517 16.3284 13.7241 17.16 13.344 17.953C13.2178 18.2173 13.2356 19.0133 13.1881 19.0608C12.9966 19.2524 12.756 19.2316 12.2319 18.7682C11.7092 18.3049 11.4375 21.0596 12.0611 21.4947C13.1272 22.2387 15.2609 25.1984 18.0776 25.1984C21.3368 25.1984 24.3554 21.7977 24.3554 19.3014C24.3554 16.8065 23.6234 15.8591 23.6709 13.7667C23.711 11.9951 24.9984 11.1501 24.9984 10.265C24.9984 9.52104 23.8922 9.33984 23.5299 9.33984C22.8855 9.33984 21.2359 10.1655 21.2359 12.3381C21.2359 13.1831 20.9938 13.9479 20.1296 13.9479C19.2655 13.9479 18.2989 12.7599 17.7153 11.8347",
    fill: "url(#paint0_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0014 10.2649C25.0014 9.85953 24.6747 9.62191 24.3169 9.48828C24.7445 10.908 22.5722 10.9703 22.5722 15.81C22.5722 20.6497 19.7555 22.0575 18.5884 22.2995C17.4213 22.5416 15.3648 22.6114 13.7998 20.6898C13.3188 20.1002 12.6669 19.4587 11.9438 18.8528C11.6379 19.3651 11.5726 21.1516 12.0641 21.4946C13.1302 22.2386 15.2639 25.1983 18.0806 25.1983C21.3398 25.1983 24.3584 21.7976 24.3584 19.3013C24.3584 16.8064 23.6264 15.859 23.6739 13.7666C23.7125 11.9965 25.0014 11.1515 25.0014 10.2649Z",
    fill: "url(#paint1_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2333 18.7683C11.7107 18.305 10.4724 16.9878 9.66758 16.3433C8.86282 15.6988 8.15901 15.7077 7.67496 16.4176C7.19241 17.1274 8.60001 18.3763 8.92222 18.6986C9.41516 19.1916 11.4375 21.0598 12.0611 21.4963",
    fill: "url(#paint2_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.496 16.2232C14.4352 16.3642 14.0253 16.4608 13.2087 15.5727C12.5851 14.8941 10.9146 12.9428 9.92873 12.0562C8.94281 11.1711 8.17813 10.8088 7.53371 11.2706C6.88929 11.734 7.25606 12.6977 7.97618 13.5041C8.86707 14.5005 9.89159 15.5163 10.8731 16.492C11.6407 17.2552 13.3779 18.8665 13.1864 19.0581",
    fill: "url(#paint3_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.717 11.8345C17.1334 10.9093 14.7384 7.93039 14.1548 7.08542C13.5713 6.24045 12.7858 6.24045 12.2439 6.62209C11.7004 7.00373 11.5401 7.76851 12.7621 9.39461C13.5327 10.4193 14.1756 11.3637 15.7154 13.0626L17.5061 12.9379L17.717 11.8345Z",
    fill: "url(#paint4_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4421 13.5659C15.1808 13.3045 12.8674 10.5617 12.3433 9.97362C11.3618 8.87172 10.119 6.51202 8.63569 7.56342C7.85617 8.11586 8.27785 8.91627 8.50056 9.23852C8.72179 9.56076 11.5994 12.8813 11.8815 13.1635C12.1636 13.4456 14.5572 16.0815 14.4978 16.2226",
    fill: "url(#paint5_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.8745 16.4951C11.5991 17.2153 13.1863 18.6899 13.2027 19.0152C13.4313 18.6573 13.0126 17.597 12.5701 17.2242C10.0148 15.071 7.54403 11.6005 7.23075 11.7044C7.09561 12.2093 7.43714 12.9028 7.97761 13.5072C8.867 14.5022 9.89302 15.5194 10.8745 16.4951Z",
    fill: "url(#paint6_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.7139 13.0635C15.9945 13.3724 16.2455 13.7748 16.1667 13.904C17.1007 13.1526 15.1259 10.9473 14.0078 9.62268C13.1422 8.59802 12.9076 7.29417 12.2869 6.59473C12.2721 6.60365 12.2572 6.61405 12.2424 6.62444C11.699 7.00608 11.5386 7.77087 12.7606 9.39697C13.5327 10.4216 14.1741 11.3646 15.7139 13.0635Z",
    fill: "url(#paint7_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.8814 13.1639C12.1635 13.4461 14.557 16.082 14.4976 16.2231C15.2371 15.2266 12.3699 12.2982 10.9816 10.8191C9.77741 9.53601 9.57101 8.41335 8.39652 7.78223C7.96 8.3094 8.30744 8.95686 8.50047 9.23903C8.7217 9.56128 11.5993 12.8818 11.8814 13.1639Z",
    fill: "url(#paint8_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.4427 16.2806C14.358 16.3326 14.1857 16.337 13.9199 16.1826C14.1174 16.3445 14.3016 16.4054 14.4427 16.2806Z",
    fill: "url(#paint9_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.27525 21.5668C9.25743 21.5668 9.23962 21.5638 9.2218 21.5594C7.38507 20.9995 5.39543 18.9918 4.96332 17.2632C4.93959 17.1667 4.99748 17.0672 5.09548 17.0434C5.19201 17.0196 5.29148 17.0776 5.31524 17.1756C5.71316 18.769 7.62563 20.6936 9.32722 21.2134C9.42225 21.2431 9.4772 21.3441 9.44752 21.4391C9.42375 21.5163 9.35246 21.5668 9.27525 21.5668Z",
    fill: "#955500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.15 23.8458C10.1366 23.8458 10.1233 23.8443 10.1084 23.8414C8.58796 23.4879 6.82249 22.3519 5.26345 20.7258C3.80535 19.2051 2.861 17.5879 2.80013 16.5054C2.79419 16.4058 2.8714 16.3197 2.97088 16.3138C3.07036 16.3078 3.15648 16.3851 3.16242 16.4846C3.21736 17.4691 4.14538 19.0359 5.52476 20.4748C7.03631 22.0519 8.7379 23.1494 10.1916 23.4879C10.2896 23.5102 10.349 23.6082 10.3267 23.7047C10.3074 23.7894 10.2331 23.8458 10.15 23.8458Z",
    fill: "#955500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.9376 7.99202C17.8575 7.99202 17.7847 7.93853 17.7624 7.85688C17.507 6.89011 16.3504 5.50162 15.2962 5.22838C15.1996 5.20314 15.1417 5.10511 15.1655 5.00711C15.1907 4.91058 15.2887 4.85265 15.3867 4.87642C16.5746 5.18382 17.8263 6.68074 18.1129 7.76333C18.1381 7.85986 18.0802 7.95933 17.9837 7.9846C17.9688 7.99051 17.9525 7.99202 17.9376 7.99202Z",
    fill: "#955500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M20.2219 8.31363C20.1417 8.31363 20.0674 8.25869 20.0467 8.17703C19.3666 5.50398 16.829 3.41902 15.3813 3.15914C15.2833 3.14132 15.218 3.04776 15.2358 2.94826C15.2537 2.85025 15.3472 2.78491 15.4467 2.80273C17.0265 3.08637 19.6739 5.23521 20.4 8.08792C20.4253 8.18445 20.3659 8.28396 20.2694 8.30772C20.2515 8.31217 20.2367 8.31363 20.2219 8.31363Z",
    fill: "#955500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M23.7036 9.64183C24.3183 9.53193 24.4267 9.60172 24.3168 9.48888C24.0169 9.37747 23.6977 9.33887 23.5329 9.33887C22.8885 9.33887 21.2388 10.1646 21.2388 12.3371C21.2388 13.1821 20.9968 13.9469 20.1326 13.9469C19.7911 13.9469 19.4348 13.7613 19.0918 13.4821C20.6108 15.1646 21.8031 13.5801 21.9842 12.4931C22.1654 11.406 21.9011 9.96705 23.7036 9.64183Z",
    fill: "url(#paint10_radial_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M12.057 6.78711C11.6813 7.21183 11.6932 7.97511 12.7608 9.39478C13.5314 10.4195 14.1744 11.3639 15.7141 13.0628C16.0066 13.3851 16.2679 13.8068 16.1566 13.9182C16.4134 12.157 13.9086 10.4269 13.0934 9.09781C12.449 8.04641 12.3198 7.42565 12.057 6.78711Z",
    fill: "url(#paint11_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.8814 13.1635C12.1635 13.4456 14.557 16.0816 14.4976 16.2226C15.0262 15.8454 14.6654 15.2588 13.8487 14.4421C12.1754 12.7685 9.84566 10.5187 8.90874 8.66684C8.81967 8.49159 8.65632 8.36241 8.46179 8.33717C7.95695 8.27183 8.33114 8.99353 8.5004 9.24007C8.72167 9.56081 11.5992 12.8813 11.8814 13.1635Z",
    fill: "url(#paint12_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M7.97754 13.505C8.86843 14.5014 9.89295 15.5172 10.8744 16.4928C11.6421 17.2561 13.3793 18.8674 13.1878 19.0589C14.2643 18.1531 9.2634 14.8756 7.2292 11.7021C7.09557 12.2071 7.43707 12.9006 7.97754 13.505Z",
    fill: "url(#paint13_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.9679 19.242C13.0704 19.2019 13.1239 19.1544 13.1402 19.1024C12.9561 19.245 12.7125 19.193 12.2329 18.7683C11.7103 18.305 10.4719 16.9877 9.66716 16.3433C9.31376 16.0596 8.97969 15.9037 8.67529 15.877C9.11185 16.1487 8.9099 16.2482 9.8795 16.9922C10.3977 17.3902 12.3027 19.5034 12.9679 19.242Z",
    fill: "url(#paint14_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11.6999 14.4116C12.4066 15.2714 13.7845 16.6926 14.4037 16.2991C14.233 16.357 13.8439 16.2635 13.2084 15.5714C12.5848 14.8928 10.9144 12.9415 9.92848 12.0549C9.12964 11.3376 8.4763 10.9634 7.91504 11.0941C9.55132 11.6346 11.0302 13.5978 11.6999 14.4116Z",
    fill: "url(#paint15_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.4647 10.7077C13.5931 11.9343 15.2651 14.3667 16.1144 13.942C15.9748 13.9851 15.6764 13.7995 15.4432 13.5663C15.1819 13.305 12.8686 10.5621 12.3444 9.97406C11.6644 9.21078 10.8596 7.84456 9.93604 7.42578C10.867 8.15938 11.5501 9.71419 12.4647 10.7077Z",
    fill: "url(#paint16_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.0903 13.483C18.5632 13.0524 18.0702 12.396 17.7168 11.8347C17.1333 10.9095 14.7383 7.93057 14.1548 7.0856C13.9766 6.82866 13.7806 6.64901 13.5771 6.53613C13.8489 6.9267 14.0018 7.48358 14.6165 8.17263C15.6025 9.27898 16.8898 11.2718 17.3337 11.9564C17.7762 12.6396 18.4904 14.083 19.0903 13.483Z",
    fill: "url(#paint17_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M22.318 23.3052C21.9513 22.4142 21.4167 21.8722 20.6431 22.3815C18.5332 23.77 16.1055 23.3023 13.0631 20.8416C10.3489 18.6467 8.94572 17.077 7.6257 16.5098C7.30944 17.2315 8.61459 18.3898 8.92343 18.6987C9.4164 19.1917 11.4387 21.0599 12.0624 21.4965C13.1285 22.2405 15.2621 25.2001 18.0788 25.2001C19.6513 25.1986 21.1688 24.4056 22.318 23.3052Z",
    fill: "url(#paint18_linear_1657_437340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M23.6727 13.7666C23.7128 11.9949 25.0001 11.15 25.0001 10.2649C25.0001 10.0035 24.865 9.81344 24.6719 9.67383C24.9081 10.3629 24.3468 10.9747 23.5108 12.0157C22.6051 13.1429 22.4046 14.8937 23.0283 16.6445C23.6519 18.3954 22.8679 20.81 21.5999 21.5748C20.3318 22.3396 18.6481 25.7002 13.8253 21.903C13.8239 21.9015 13.8239 21.9015 13.8224 21.9C13.5284 21.6268 13.2374 21.3847 12.9419 21.2021C10.9047 19.9398 9.74507 18.8052 8.86752 17.8519C8.69528 17.6647 8.23202 16.9445 7.67969 17.1821C7.95584 17.8073 8.69973 18.4741 8.92247 18.6983C9.41541 19.1913 11.4377 21.0595 12.0614 21.4961C12.1431 21.5525 12.2306 21.6223 12.3242 21.7025C12.348 21.7233 12.3732 21.7441 12.3984 21.7664C12.4044 21.7723 12.4118 21.7782 12.4177 21.7842C12.4341 21.799 12.4489 21.8124 12.4652 21.8273C12.4682 21.8302 12.4727 21.8332 12.4756 21.8376C13.1082 22.4124 13.9798 23.3643 15.0474 24.1082C15.0474 24.1082 15.0488 24.1082 15.0488 24.1097C15.1424 24.1751 15.2374 24.2389 15.3339 24.3013C15.3354 24.3028 15.3369 24.3028 15.3384 24.3042C15.4349 24.3651 15.5314 24.4245 15.6309 24.481C15.6324 24.481 15.6324 24.4825 15.6339 24.4825C16.3733 24.9072 17.1914 25.1997 18.0764 25.1997C21.3356 25.1997 24.3542 21.799 24.3542 19.3027C24.3572 16.8064 23.6252 15.859 23.6727 13.7666Z",
    fill: "url(#paint19_linear_1657_437340)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1657_437340",
    x1: 22.7725,
    y1: 25.8433,
    x2: 20.0856,
    y2: 19.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1657_437340",
    x1: 25.0553,
    y1: 26.8266,
    x2: 20.1847,
    y2: 18.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1657_437340",
    x1: 8.24721,
    y1: 16.9904,
    x2: 11.5677,
    y2: 19.4352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1657_437340",
    x1: 7.03811,
    y1: 10.5186,
    x2: 12.8644,
    y2: 16.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1657_437340",
    x1: 13.3305,
    y1: 7.64125,
    x2: 16.7117,
    y2: 12.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1657_437340",
    x1: 9.84081,
    y1: 8.52368,
    x2: 14.4295,
    y2: 14.7217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1657_437340",
    x1: 11.51,
    y1: 14.1399,
    x2: 9.58412,
    y2: 15.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1657_437340",
    x1: 15.2973,
    y1: 9.27268,
    x2: 12.3993,
    y2: 11.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1657_437340",
    x1: 12.6318,
    y1: 11.1361,
    x2: 8.64715,
    y2: 14.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1657_437340",
    x1: 15.5999,
    y1: 15.1962,
    x2: 11.6154,
    y2: 18.1095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1657_437340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8306 10.4665) scale(4.783 4.78366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBA94",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1657_437340",
    x1: 15.8278,
    y1: 8.7582,
    x2: 13.3524,
    y2: 11.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3072,
    stopColor: "#D2A374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1657_437340",
    x1: 13.932,
    y1: 10.0014,
    x2: 10.6718,
    y2: 12.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3072,
    stopColor: "#D2A374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1657_437340",
    x1: 12.8301,
    y1: 13.1794,
    x2: 8.80522,
    y2: 16.5599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3072,
    stopColor: "#D2A374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1657_437340",
    x1: 8.43873,
    y1: 15.6359,
    x2: 13.1177,
    y2: 19.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#DEBA94",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1657_437340",
    x1: 9.33415,
    y1: 10.9216,
    x2: 12.9871,
    y2: 16.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#D2A374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1657_437340",
    x1: 12.1951,
    y1: 11.3181,
    x2: 13.2214,
    y2: 10.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1657_437340",
    x1: 16.4326,
    y1: 9.48453,
    x2: 14.5406,
    y2: 19.5872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#DEBA94",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1657_437340",
    x1: 15.487,
    y1: 19.0073,
    x2: 12.6291,
    y2: 23.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1657_437340",
    x1: 24.7387,
    y1: 30.3583,
    x2: 12.7834,
    y2: 6.57167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#D2A374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBA94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/waving_hand.13918af68e55693d21f0f5be43f663ec.svg";
export { ForwardRef as ReactComponent };